var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "shop-checkout" },
    [
      _vm.showDemoStuff
        ? _c(
            "div",
            {
              staticStyle: {
                "background-color": "goldenrod",
                border: "3px dashed darkgoldenrod",
              },
            },
            [
              _vm._v("\n        Set Demo-Cookies for\n        "),
              _c(
                "button",
                { staticClass: "button", on: { click: _vm.setCartButton } },
                [_vm._v("DACH_cart")]
              ),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "button", on: { click: _vm.setWishlistButton } },
                [_vm._v("DACH_wishlist")]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.cart ? _c("shop-cart") : _vm._e(),
      _vm._v(" "),
      !_vm.cart ? _c("shop-wishlist") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }